import {
  sendResetPasswordOtp,
  sendSignupOtp,
} from "../../services/otp.service.js";
import AppError from "../../utils/AppError.js";
import getMessage from "../../utils/getMessage.js";
import "../../styles/auth/verifyOtp.css";

const ResendOtpButton = (props = {}) => {
  const {
    email,
    resending,
    verifying,
    setError,
    setResending,
    setOtp,
    inputsRef,
    type,
  } = props;
  const resendOtp = async (event) => {
    event.preventDefault();
    setError(null);
    setResending(true);

    try {
      type === "signup"
        ? await sendSignupOtp({ email })
        : await sendResetPasswordOtp({ email });
      setOtp(["", "", "", "", "", ""]);
      inputsRef.current[0]?.focus();
    } catch (error) {
      if (error instanceof AppError) {
        setError(error.message);
      } else {
        setError(getMessage("common", "error"));
      }
    } finally {
      setResending(false);
    }
  };
  return (
    <button
      type="button"
      className="resend-otp"
      onClick={resendOtp}
      disabled={resending || verifying}
    >
      {resending ? "Resending OTP..." : "Resend OTP"}
    </button>
  );
};

export default ResendOtpButton;
